var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArena(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0679 13.0094C4.78317 14.0767 5.41702 15.1745 6.48364 15.4616L11.9442 16.9311C13.0108 17.2182 14.1063 16.5857 14.3911 15.5185L16.9316 5.99573C17.2163 4.92849 16.5825 3.83062 15.5158 3.54358L10.0553 2.07404C8.98863 1.78699 7.89315 2.41947 7.60843 3.48671L5.0679 13.0094ZM6.74141 14.4954C6.2081 14.3519 5.89118 13.8029 6.03354 13.2693L8.57407 3.74658C8.71643 3.21296 9.26417 2.89672 9.79748 3.04025L15.2581 4.50978C15.7914 4.65331 16.1083 5.20224 15.9659 5.73586L13.4254 15.2586C13.283 15.7922 12.7353 16.1084 12.202 15.9649L6.74141 14.4954ZM4.0009 10.4725L2.67021 5.50626C2.38432 4.43933 3.01749 3.34266 4.08442 3.05677L4.15961 3.03663C4.05671 3.33958 4.0009 3.66428 4.0009 4.00202V4.18917C3.68459 4.42718 3.52739 4.84162 3.63613 5.24745L4.0009 6.60877V10.4725ZM5 9.38458V4.00195C5 2.89738 5.89543 2.00195 7 2.00195H7.10603C6.9585 2.22332 6.8441 2.4723 6.77167 2.74379L6.6897 3.05103C6.28932 3.18159 6 3.55799 6 4.00195V5.63626L5 9.38458ZM13 6.00031C13 6.55259 12.5523 7.00031 12 7.00031C11.4477 7.00031 11 6.55259 11 6.00031C11 5.44802 11.4477 5.00031 12 5.00031C12.5523 5.00031 13 5.44802 13 6.00031ZM10 14.0003C10.5523 14.0003 11 13.5526 11 13.0003C11 12.448 10.5523 12.0003 10 12.0003C9.44772 12.0003 9 12.448 9 13.0003C9 13.5526 9.44772 14.0003 10 14.0003Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArena);
export default __webpack_public_path__ + "static/media/arena.3a5cbe784522f3e222e44f0427edf55c.svg";
export { ForwardRef as ReactComponent };